import { Grid } from '@mui/material';
import { usePatientList } from 'app/hooks';
import { Breadcrumb, Button, FileUpload, List, ListWrapperDiv, TextField } from 'app/shared';
import { formatDate, ROUTES } from 'app/utils';
import { t } from 'i18next';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const PatientList = () => {
  const { list, page, handlePageChange, pageSize, handlePageSizeChange, handleFilter, count, loading, importCSV } =
    usePatientList();

  const navigate = useNavigate();

  const [search, setSearch] = useState<string>();

  const handleSearch = (newSearch?: string) => {
    setSearch(newSearch);
  };

  return (
    <>
      <Breadcrumb />
      <ListWrapperDiv>
        <Grid container spacing={2} paddingBottom={2} display={'flex'} alignItems={'center'}>
          <Grid size={4}>
            <TextField
              value={search}
              size="small"
              onChange={(e) => handleSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleFilter(search);
                  e.preventDefault();
                }
              }}
            />
          </Grid>
          <Grid size={4}>
            <Button
              onClick={() => {
                handleFilter(search);
              }}
            >
              {t('actions.search')}
            </Button>
          </Grid>
        </Grid>
        <List
          list={list}
          count={count}
          page={page}
          pageSize={pageSize}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          loading={loading}
          keyGetter={(el) => el.id}
          onItemClick={(el) => navigate(el.id)}
          listMaxHeight="calc(100vh - 310px)"
          gridTemplateColumns="1fr 1fr 130px 1fr 1fr"
          actions={
            <>
              <FileUpload
                label={t('actions.import')}
                onFileSelect={importCSV}
                onlyButton
                loading={loading}
                acceptFiles=".csv,text/csv"
              />
              <Button onClick={() => navigate(ROUTES.new)}>{t('actions.create')}</Button>
            </>
          }
          fields={[
            {
              key: 'last_name',
              title: t('patient.lastName'),
            },
            {
              key: 'first_name',
              title: t('patient.firstName'),
            },
            {
              key: 'birth_date',
              title: t('patient.birthDate'),
              valueGetter: (patient) => formatDate(patient.birth_date),
            },
            {
              key: 'tax_code',
              title: t('patient.taxCode'),
            },
            {
              key: 'company',
              title: t('patient.company'),
              path: ['name'],
            },
          ]}
        />
      </ListWrapperDiv>
    </>
  );
};
